import { FC } from 'react';

import {
  Button,
  Card,
  Icon,
  Tooltip,
} from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont';

import { Column } from 'src/components/Column/Column';
import { Truncate } from 'src/components/Truncate/Truncate';

import { SpaceCardComponentProps } from '../types';

import classes from './MobileSpaceCard.module.scss';
import { mobileSpaceCardStyle } from './consts';

export const MobileSpaceCard: FC<SpaceCardComponentProps> = ({
  title,
  org,
  desksCount,
  onOpen,
  onDelete,
  disabled,
}) => {
  return (
    <Card
      border='default'
      className={classes.card}
      style={mobileSpaceCardStyle}
      onClick={onOpen}
    >
      <div className={classes.container}>
        <Column
          title='Название'
          content={<Truncate variant='body3'>{title}</Truncate>}
          testId='spaceTitle'
        />
        <Column
          title='Подразделение'
          content={<Truncate variant='body3'>{org}</Truncate>}
          testId='spaceDepartment'
        />
        <Column
          title='Места'
          content={<Truncate variant='body3'>{desksCount}</Truncate>}
          className={classes.desksCount}
          testId='spaceDesksCount'
        />
        <Button
          size='medium'
          onClick={onDelete}
          data-testid='deleteSpace'
          disabled={disabled}
        >
          Удалить
        </Button>
      </div>
    </Card>
  );
};
